import React, { useState } from "react";
import { MdSecurity, MdSearch, MdBuild, MdReportProblem, MdDescription, MdChecklist, MdDashboard, MdAssessment, MdQrCodeScanner, MdGroup } from "react-icons/md";
import "../styles/Features.css";

const featuresData = [
  { id: 1, title: "Rondas", description: "Controle de rondas por QR Code, podendo ser programadas ou aleatórias. Garante a segurança e fiscalização eficiente das áreas.", icon: MdSecurity },
  { id: 2, title: "Inspeções", description: "Verificação detalhada de áreas ou ativos via QR Code, podendo ser programadas ou aleatórias, assegurando a conformidade operacional.", icon: MdSearch },
  { id: 3, title: "Ativos", description: "Gestão de ativos da empresa/condomínio via QR Code, com manutenção preventiva, reativa e controle completo de equipamentos.", icon: MdBuild },
  { id: 4, title: "Ocorrências", description: "Registro e acompanhamento de ocorrências geradas por rondas, inspeções ou manutenções de ativos, facilitando a resolução rápida de problemas.", icon: MdReportProblem },
  { id: 5, title: "Serviços", description: "Gestão de documentos essenciais como AVCB, notas fiscais e garantias de equipamentos, garantindo controle e conformidade.", icon: MdDescription },
  { id: 6, title: "Lista de Tarefas/Checklist", description: "Tarefas operacionais programadas, com alertas automáticos e horários definidos, garantindo organização e eficiência.", icon: MdChecklist },
  { id: 7, title: "Dashboard", description: "Painéis estatísticos com leitura rápida dos eventos do condomínio ou empresa, podendo ser exibidos em TVs gerenciais.", icon: MdDashboard },
  { id: 8, title: "Relatórios", description: "Informações detalhadas em tabelas gerenciais, permitindo filtros personalizados para melhor controle das atividades.", icon: MdAssessment },
  { id: 9, title: "Gestão de QR Codes", description: "Controle centralizado de QR Codes para áreas e ativos, garantindo segurança e gestão eficiente pelo administrador.", icon: MdQrCodeScanner },
  { id: 10, title: "Gestão de Colaboradores e Perfis", description: "Distribuição de responsabilidades e tarefas simultâneas para a equipe operacional, garantindo fluxo de trabalho otimizado.", icon: MdGroup }
];

const Features = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="features" className="features">
      <h2>Funcionalidades do RondaGO</h2>
      <p style={{ textAlign: "center", fontSize: "22px", fontWeight: "bold" }}>
        Conheça os principais recursos do RondaGO e como eles podem otimizar sua gestão.
      </p>

      <div className="features-grid">
        {featuresData.map((feature) => (
          <div 
            className="feature-item" 
            key={feature.id}
            onMouseEnter={() => setHovered(feature.id)}
            onMouseLeave={() => setHovered(null)}
          >
            <feature.icon 
              size={40} 
              color={hovered === feature.id ? "#fff" : "#16213e"} 
            />
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
